import React from "react";
import { AiFillStar } from "react-icons/ai";
import "../../Home/Clinets/Clients.css"; // Using unified styles

const testimonialData = [
  {
    id: 1,
    name: "Jemma Stone",
    imageSrc:
      "https://images.pexels.com/photos/1043474/pexels-photo-1043474.jpeg?auto=compress&cs=tinysrgb&w=600",
    rating: 5,
    text: "The software company provided excellent customer service and their product exceeded our expectations. We highly recommend this software company to anyone looking for a reliable and efficient solution.",
  },
  {
    id: 2,
    name: "Bilal Saeed",
    imageSrc:
      "https://images.pexels.com/photos/1073097/pexels-photo-1073097.jpeg?auto=compress&cs=tinysrgb&w=600",
    rating: 5,
    text: "The software company was very responsive to our needs and provided a solution that exceeded our expectations. I highly recommend this software company for their outstanding customer service and innovative products.",
  },
  {
    id: 3,
    name: "Richard Anthony",
    imageSrc:
      "https://www.vaival.com/wp-content/uploads/2019/08/m8-150x150.jpg",
    rating: 5,
    text: "The software company provided excellent customer service and their product exceeded our expectations. We highly recommend this software company to anyone looking for a reliable and efficient solution.",
  },
  {
    id: 4,
    name: "Michle",
    imageSrc:
      "https://www.vaival.com/wp-content/uploads/2019/08/m2_bw-150x150.jpg",
    rating: 5,
    text: "TopSpot Is A Very Professional, Courteous, Flexible Company Who Got The Job Done. I Was Very Satisfied With The Project As A Whole. TopSpot Is A Company Of Integrity And Will Get The Job Done For You In A Swift, Orderly, And Flexible Fashion.",
  },
];

const Testimonila = () => {
  // Duplicate for infinite marquee
  const doubleTestimonials = [...testimonialData, ...testimonialData];

  return (
    <section className="testimonial-section">
      <div className="client-header">
        <div className="section-badge">Client Stories</div>
        <h2 className="section-title">
          What Our <span className="gradient-text">Partners Say</span>
        </h2>
      </div>

      <div className="testimonial-marquee-wrapper">
        <div className="testimonial-marquee-content">
          {doubleTestimonials.map((testimonial, index) => (
            <div key={`${testimonial.id}-${index}`} className="monial-card">
              <div className="text_star">
                {Array.from({ length: testimonial.rating }, (_, i) => (
                  <AiFillStar key={i} />
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="client-info">
                <img src={testimonial.imageSrc} alt={testimonial.name} />
                <p className="client-name">{testimonial.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonila;
